import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';
import logo from '../../LOGO-PRODUCTO-removebg-preview.png';
import qrImage from '../../assets/qr-removebg-preview.png';
import FreeVersion from './examples/FreeVersion';
import CurrentVersion from './examples/CurrentVersion';
import PremiumVersion from './examples/PremiumVersion';
import SignIn from '../HomeAdmins/login/SignIn';



function CentralHome({
  visibilityCurrent, 
  visibilityFree, 
  visibilityPremium, 
  centralVisibility, 
  setCentralVisibility,
  setVisibilityCurrent, 
  setVisibilityFree, 
  setVisibiliyPremium,
  loginVisibility,
  setLoginVisibility,
  setAdmin,
  admin
}) {
  const [visualizationTestConditions, setVisualizationTestConditions] = useState(false);
  const [inputEmail, setInputEmail] = useState("");
  const [inputName, setInputName] = useState("");
  const [inputAccept, setInputAccept] = useState(false);
const [reload, setReload] = useState(0)
  const [loading, setLoading] = useState("");
  const [visualizationBtnWts, setVisualizationBtnWts] = useState(false);
  const apiCentral = "https://apicentral-67bm.onrender.com";
  const navigate = useNavigate();

  const changeEmail = (e) => {
    setInputEmail(e.target.value);
    
  };

  const changeName = (e) => {
    setInputName(e.target.value);
  };

  const changeInputAccept = (e) => {
    setInputAccept(prevState => !prevState); // Invertir el estado de manera segura
    console.log("inputaccept: ", e.target.checked); // Aquí puedes verificar si el checkbox está marcado
  };
  
  const visualizationTestConditionFunction = () => {
    setVisualizationTestConditions(true);
  };


  // const submitFunction = (e) => {
   
  //   postConditions(e)
  //   setVisualizationBtnWts(true)
  //  }
  // loading logic
  
  useEffect(() => {
    // Si aún no se ha mostrado el botón y el estado de reload es al menos 1, mostramos el mensaje de carga.
    if (!visualizationBtnWts && reload >= 1) {
      setLoading("Cargando.");
    } else {
      // Si ya se ha mostrado el botón de WhatsApp o aún no hemos hecho un reload, no mostramos el mensaje de carga.
      setLoading("");
    }
  }, [reload, visualizationBtnWts]);

  const conditionsFunction = () => {
    return(<div className="container-terms">
      <div className="header-terms">
        <h1 className='title-terminos-y-condiciones'>Términos y Condiciones</h1>
        <p><strong>Fecha de Entrada en Vigor:</strong> [17/02/2025]</p>
      </div>

      <div className="section-terms">
  <h2>Requisitos del Sistema</h2>
  <ul>
    <li><strong>1.</strong> Una conexión a internet estable es esencial para el correcto desempeño del sistema de seguridad IP.</li>
    <li><strong>2.</strong> Es necesario disponer de una computadora en el área de recepción o cocina, dado que la interfaz de administración no está disponible en dispositivos móviles.</li>
  </ul>
</div>

      <div className="section-terms">
        <h2>1. Descripción del Servicio</h2>
        <p>Nuestro software de menús con códigos QR ofrece a los usuarios la posibilidad de acceder a menús en dos idiomas. Este servicio será gratuito temporalmente, pero eventualmente comenzará a cobrarse una tarifa.</p>
      </div>
    
      <div className="section-terms">
        <h2>2. Datos y Privacidad</h2>
        <p>Nosotros podemos tratar los datos recopilados a través de nuestro software de acuerdo con nuestras propias políticas de privacidad. Al utilizar nuestro servicio, aceptas que tus datos puedan ser manejados de esta manera.</p>
      </div>
    
      <div className="section-terms">
        <h2>3. Limitaciones del Servicio</h2>
        <p>Nuestro software actualmente carece de una base de datos. El uso del servicio es limitado a nuestra consideración y nos reservamos el derecho de modificar o interrumpir el servicio en cualquier momento sin previo aviso.</p>
      </div>
    
      <div className="section-terms">
        <h2>4. Tarifas y Pagos</h2>
        <p>El servicio será gratuito temporalmente, pero se implementará una tarifa en el futuro. Las tarifas serán especificadas en su debido momento y estarán sujetas a cambios a nuestra discreción.</p>
      </div>
    
      <div className="section-terms">
        <h2>5. No Reembolsos</h2>
        <p>Todos los pagos realizados por el uso de nuestro software son definitivos y no se proporcionarán reembolsos bajo ninguna circunstancia.</p>
      </div>
    
      <div className="section-terms">
        <h2>6. Condiciones de Uso</h2>
        <p>El uso de nuestro software está sujeto a las siguientes condiciones:</p>
        <ul>
          <li>Aceptas no utilizar el software para actividades ilegales o no autorizadas.</li>
          <li>Nos reservamos el derecho de suspender o cancelar tu acceso al servicio en caso de violación de estos términos.</li>
        </ul>
      </div>
    
      <div className="section-terms">
        <h2>7. Modificaciones a los Términos y Condiciones</h2>
        <p>Nos reservamos el derecho de actualizar o modificar estos términos y condiciones en cualquier momento sin previo aviso. Te recomendamos revisar periódicamente estos términos para estar al tanto de cualquier cambio.</p>
      </div>
    
      <div className="section-terms">
        <h2>8. Contacto</h2>
        <p>Si tienes alguna pregunta sobre estos términos y condiciones, por favor contáctanos a través de nuestro servicio de atención al cliente.</p>
      </div>
    
      <div className="section-terms">
        <h2>9. Publicidad y Pagos Adicionales</h2>
        <p>
          El servicio puede incluir publicidad en el software. Nos reservamos el derecho de mostrar anuncios en cualquier momento. Si prefieres utilizar el servicio sin anuncios, tendrás la opción de pagar una tarifa adicional para eliminar la publicidad. Los detalles de esta tarifa se proporcionarán cuando se ofrezca la opción.
        </p>
      </div>
    
      <div className="footer-terms">
        <p>&copy; CookerOnConnection [17-03-2025]. <strong>Cristian Camilo Medina Sanchez, Robinson Alberto Medina Sanchez. </strong><br></br>  Todos los derechos reservados.</p>
      </div>
    </div>
    

    )
  }

//   const postConditions = async (e) => {
//     e.preventDefault();

// const idname = document.getElementById("input-name")

// const idemail = document.getElementById("input-email")

// const idcheckbox = document.getElementById("input-checkbox")

//     // Validar que todos los campos sean válidos
//     if (!inputEmail || !inputName || !inputAccept) {
//         alert("Por favor, completa todos los campos y acepta los términos.");
//         return;
//     }
//     setReload(reload + 1)
//     // Validar el formato del correo electrónico en el frontend
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(inputEmail)) {
//         alert("Por favor, ingrese un correo electrónico válido.");
//         return;
//     }

//     const body = {
//         email: inputEmail,
//         nombreCompleto: inputName,
//         aprobo: inputAccept  // Aquí se incluye el valor booleano de `inputAccept`
//     };
//     console.log("Request body:", body);

//     const config = {
//         method: "POST",
//         headers: {
//             "Content-Type": "application/json"
//         },
//         body: JSON.stringify(body)  // Enviamos el valor de `aprobo` como parte del cuerpo de la solicitud
//     };

//     try {
//         const response = await fetch(`${apiCentral}/api/increase/conditions`, config);
//         if (response.ok) {
//           idname.value = ""
//           idemail.value =""
//           idcheckbox.checked = false  
//           setVisualizationBtnWts(true); // Cambia el estado si la solicitud es exitosa
//         } else {
//             console.error("Failed to post conditions");
//         }
//     } catch (error) {
//         console.error("Error posting conditions:", error);
//     }
// };

const postConditions = async (e) => {
  e.preventDefault();

  const idname = document.getElementById("input-name");
  const idemail = document.getElementById("input-email");
  const idcheckbox = document.getElementById("input-checkbox");

  // Validar que todos los campos sean válidos
  if (!inputEmail || !inputName || !inputAccept) {
    alert("Por favor, completa todos los campos y acepta los términos.");
    return;
  }

  // Validar el formato del correo electrónico en el frontend
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(inputEmail)) {
    alert("Por favor, ingrese un correo electrónico válido.");
    return;
  }

  const body = {
    email: inputEmail,
    nombreCompleto: inputName,
    aprobo: inputAccept,  // Aquí se incluye el valor booleano de `inputAccept`
  };

  console.log("Request body:", body);

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),  // Enviamos el valor de `aprobo` como parte del cuerpo de la solicitud
  };

  // Actualizar el estado antes de hacer la solicitud para reflejar que la operación está en curso
 

  try {
    // Realizamos la solicitud POST
    const response = await fetch(`${apiCentral}/api/increase/conditions`, config);

    if (response.ok) {
      // Si la solicitud fue exitosa, limpiamos los campos
      idname.value = "";
      idemail.value = "";
      idcheckbox.checked = false;

      // Cambia el estado para mostrar el botón después de la respuesta exitosa
      setVisualizationBtnWts(true);
      setLoading("")
    } else {
      console.error("Failed to post conditions");
    }
  } catch (error) {
    console.error("Error posting conditions:", error);
  }
};

const loadConditions = (e) => {
  setReload(prevReload => prevReload + 1);
  postConditions(e)
}
  const functionTestConditions = () => {
    return (
      <div className='container-terminos-y-condiciones'>
        <div className='inside-container-terminos-y-condiciones'>
      
{conditionsFunction()}
        
          <p></p>
        </div>

        <div className='inside-container-terminos-y-condicinoes-inputs'>
         
          <div style={{display: "flex", flexDirection: "column"}}>
          <input onChange={changeName} id='input-name' className='input-terminos' placeholder='Nombre Completo' />
          <input onChange={changeEmail} id='input-email' className='input-terminos' placeholder='Email' />
          </div>
        <div className='accept-container'>
          <input className='chekbox-accept' id='input-checkbox' onChange={changeInputAccept} type="checkbox" />
          <p className='accept-conditions'>
Acepto las condiciones y politica de CookerOnConnection</p>

</div>
        </div>
        {loading && 
        <div className='container-loading-x' style={{boxShadow: "0 0 8px #fff, 0 0 15px #fff, 0 0 25px #9acd32;", display: "flex", flexDirection: "column"}}>
          <p style={{color: "#007bff" }}>{loading}</p>
          <span style={{color: "#ff6f00", marginBottom: "10px"}}>Espere un momento por favor.</span>
          </div>
          }
        <div className='container-btn-test'>
          {/* {!visualizationBtnWts &&<button onClick={(e) => loadConditions(e)}>Aceptar</button>} */}
          {/* {visualizationBtnWts && <button className='wtp-btn'><a target='_blank' href="https://wa.me/573107935885">Contactanos</a></button>} */}
          <button className='wtp-btn'><a target='_blank' href="https://wa.me/573107935885">Contactanos</a></button>
        </div>
      </div>
    );
  };

  const navigateFunction = (e) => {
    e.preventDefault();
    navigate("/service1");
  };

  return (
    <div className="page-container">
      {centralVisibility && (
        <>
          {/* Condiciones de visibilidad de toda la aplicación
          {!visualizationTestConditions && (
            <div className='container-initiated'>

              <div className='container-imgqr-and-slogan'>
              
                <div>
                  <img className='qr-img' src={qrImage} />
                  
                <h1 className="slogan"><span>Innovación</span></h1>
                
                </div>
                <div><h2 style={{ color: "#ff6f00" }}>Al alcance de tu mesa</h2></div>
              
                <div className='container-central-btn'>
                  <button className='button-first-style' onClick={visualizationTestConditionFunction}>Contactanos</button>
                </div>
                </div>
              </div>
            
          )}
          {visualizationTestConditions && functionTestConditions()} */}

<div className='container-initiated'>
  {!visualizationTestConditions ? (
    <div className='container-imgqr-and-slogan'>
      <div>
         <img  className='mini-logo' src={logo} />
        
        <img className='qr-img' src={qrImage} />
        <h1 className="slogan"><span style={{color: "#ff6f00;"}}>Innovación</span> al alcance de tu mesa.</h1>
      </div>
      {/* <div><h2 style={{ color: "#ff6f00" }}>Al alcance de tu mesa</h2></div> */}
      <div className='container-central-btn'>
        {/* <button className='button-first-style' onClick={visualizationTestConditionFunction}>Contactanos</button> */}
        <button className='wtp-btn'><a target='_blank' href="https://wa.me/573107935885">Contactanos</a></button>
      </div>
    </div>
  ) : (
    functionTestConditions()
  )}
</div>


          {/* Contenedor del video */}
          <div className='youtube-container'>
            <div className='react-player-container' style={{ position: 'relative', maxWidth: '100%' }}>
              <ReactPlayer
                url="https://www.youtube.com/watch?v=4JZ6MBPEQzM"
                playing={true}
                controls={true}
                width="100%"
                height="100%"
              />
              <h1 style={{marginTop: "20px", fontWeight: "bold", color: "#007bff"}}>CEO <span style={{color: "#ff6f00"}}>Cristian Camilo Medina Sanchez</span></h1>
            </div>
          </div>
          <div className="cybercook-plans">
            <h1 className="title">Planes de CyberCook</h1>
            <div className="service-list">
              {/* Versión Gratis */}
              <div className="service-card">
                <h2 className="service-title">Basic Version</h2>
                <p className="service-price">¡Gratis!</p>
                <p className='free-title'>Por tiempo limitado</p>
                <ul className="service-benefits">
                  <li><strong>QR para pedidos en tiempo real</strong></li>
                  <li><strong>Dos lenguajes</strong></li>
                  <li><strong>Imágenes y efectos de sonido incluidos</strong></li>
                  <li ><strong>Chat para restaurante</strong></li>
                  <li><strong>Soporte en linea</strong></li>
                  <li className="not-included">Base de datos</li>
                  <li className="not-included">Pedido de mesero por parte de clientes</li>
                  <li className="not-included">Opciones de edición de menú por el dueño</li>
                  <li className="not-included">Registro de personal</li>
                  <li className="not-included">Blog para anuncios del restaurante</li>
                </ul>
              </div>
              {/* Versión Corriente */}
              <div className="service-card">
                <h2 className="service-title">Standar Version</h2>
                <p className="service-price">¡Proximamente!</p>
                <ul className="service-benefits">
                  <li><strong>Base de datos</strong></li>
                  <li><strong>Limitacion ingreso de app</strong></li>
                  <li><strong>Registro</strong></li>
                  <li><strong>Control de mesas</strong></li>
                  <li><strong>Pedido de mesero</strong></li>
                  <li><strong>Soporte en linea</strong></li>
                  <li className="not-included">Registro de personal</li>
                  <li className="not-included">Blog para anuncio restaurante</li>
                  <li className="not-included">Ajustes avanzados</li>
                </ul>
              </div>
            </div>
            <div className='container-footer'>
            {/* <p style={{ justifyContent: "center" }}>
                    Un correcto flujo de trabajo mediante aplicaciones es el futuro al que su restaurante podrá acceder hoy,
                    solamente debe enviarnos un mensaje de WhatsApp al +573107935885!
                  </p> */}
              <p className='p-footer'>Aplica condiciones y restricciones.</p>
            </div>
          </div>
        </>
      )}
      {visibilityFree && <FreeVersion />}
      {visibilityCurrent && <CurrentVersion />}
      {visibilityPremium && <PremiumVersion />}
      {loginVisibility && <SignIn setAdmin={setAdmin} admin={admin} />}
    </div>
  );
}

export default CentralHome;
